import { render } from "./matching-list-interests-mutual.vue?vue&type=template&id=6a336298&scoped=true&ts=true"
import script from "./matching-list-interests-mutual.vue?vue&type=script&lang=ts"
export * from "./matching-list-interests-mutual.vue?vue&type=script&lang=ts"

import "./matching-list-interests-mutual.vue?vue&type=style&index=0&id=6a336298&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a336298"]])

export default __exports__